import { useState, useMemo } from "react";
import { useOktaAuth } from "@okta/okta-react";

const menuItemBase = "block w-full rounded-md px-3 py-2 text-left text-sm transition-colors";

export const UserMenu = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const [open, setOpen] = useState(false);

  const userInfo = authState?.idToken?.claims;

  const initials = useMemo(() => {
    if (!userInfo?.name) return "?";
    const parts = String(userInfo.name).split(" ");
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
    }
    return String(userInfo.name)[0].toUpperCase();
  }, [userInfo?.name]);

  const displayName = userInfo?.name || "User";
  const email = userInfo?.email || "";

  const handleSignOut = async () => {
    try {
      await oktaAuth.signOut();
    } catch (error) {
      console.error("Failed to sign out", error);
    }
  };

  if (!authState?.isAuthenticated) {
    return (
      <div className="h-10 w-10 animate-pulse rounded-full bg-gray-200" aria-hidden />
    );
  }

  return (
    <div className="relative">
      <button
        type="button"
        className="flex h-10 w-10 items-center justify-center rounded-full bg-wppBlue font-semibold text-white shadow-lg shadow-black/10 transition-transform hover:-translate-y-0.5"
        onClick={() => setOpen((prev) => !prev)}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label="Account menu"
      >
        {initials}
      </button>
      {open && (
        <div
          role="menu"
          className="absolute right-0 z-50 mt-2 w-56 rounded-xl border border-gray-200 bg-white p-2 shadow-2xl"
        >
          <div className="px-3 py-2 text-sm text-gray-600">
            <p className="font-semibold text-gray-900">{displayName}</p>
            <p className="text-xs text-gray-500">{email}</p>
          </div>

          <div className="my-2 border-t border-gray-200" />

          <a
            href="https://wundertracker.atlassian.net/jira/software/c/form/c4c9fe71-8a52-4272-8661-7d242c13ebff"
            target="_blank"
            rel="noopener noreferrer"
            role="menuitem"
            className={`${menuItemBase} text-gray-700 hover:bg-gray-100`}
            onClick={() => setOpen(false)}
          >
            Request User Access
          </a>

          <a
            href="https://wundertracker.atlassian.net/jira/software/c/form/923bfa25-ee1b-4869-886c-e2ad910a33b2"
            target="_blank"
            rel="noopener noreferrer"
            role="menuitem"
            className={`${menuItemBase} text-gray-700 hover:bg-gray-100`}
            onClick={() => setOpen(false)}
          >
            Report Bug / Request Feature
          </a>

          <div className="my-2 border-t border-gray-200" />

          <button
            type="button"
            role="menuitem"
            className={`${menuItemBase} text-red-700 hover:bg-red-100`}
            onClick={() => {
              setOpen(false);
              handleSignOut();
            }}
          >
            Sign Out
          </button>
        </div>
      )}
      {open && (
        <button
          type="button"
          className="fixed inset-0 z-40 h-full w-full cursor-default"
          aria-hidden
          onClick={() => setOpen(false)}
        />
      )}
    </div>
  );
};
